export const pregnancyRestrictedVaccines = {
  'measles, mumps, and rubella (MMR)': true,
  'hepatitis B': true,
  chickenpox: true,
  HPV: true,
  shingles: true,
};
